/* eslint-disable jsx-a11y/scope */
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
const ES6Update = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [formData, setFormData] = useState({
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        EmploymentId: Number(props.employmentId),
        _8DigitNco20152: 0,
        Total3: 0,
        OutstandingPreviousMonthTotal3: 0,
        OutstandingPreviousMonthWomen4: 0,
        OutstandingPreviousMonthSc5: 0,
        OutstandingPreviousMonthSt6: 0,
        OutstandingPreviousMonthObc7: 0,
        NotifiedTotal8: 0,
        NotifiedWomen9: 0,
        NotifiedSc10: 0,
        NotifieSt11: 0,
        NotifiedObc12: 0,
        FilledTotal13: 0,
        FilledWomen14: 0,
        FilledSc15: 0,
        FilledSt16: 0,
        FilledObc17: 0,
        CancelledTotal18: 0,
        CancelledWomen19: 0,
        CancelledSc20: 0,
        CancelledSt21: 0,
        CancelledObc22: 0,
        OutstandingCurrentMonthTota23: 0,
        OutstandingCurrentMonthWomen24: 0,
        OutstandingCurrentMonthSc25: 0,
        OutstandingCurrentMonthSt26: 0,
        OutstandingCurrentMonthObc27: 0,

    });


    const getdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            ParametersId: Number(props.parametersId),
            EmploymentId: Number(props.employmentId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetES6Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                    //console.log(maindata)
                    setFormData({

                        OutstandingPreviousMonthTotal3: maindata.outstandingPreviousMonthTotal3,
                        OutstandingPreviousMonthWomen4: maindata.outstandingPreviousMonthWomen4,
                        OutstandingPreviousMonthSc5: maindata.outstandingPreviousMonthSc5,
                        OutstandingPreviousMonthSt6: maindata.outstandingPreviousMonthSt6,
                        OutstandingPreviousMonthObc7: maindata.outstandingPreviousMonthObc7,
                        NotifiedTotal8: maindata.notifiedTotal8,
                        NotifiedWomen9: maindata.notifiedWomen9,
                        NotifiedSc10: maindata.notifiedSc10,
                        NotifieSt11: maindata.notifieSt11,
                        NotifiedObc12: maindata.notifiedObc12,
                        FilledTotal13: maindata.filledTotal13,
                        FilledWomen14: maindata.filledWomen14,
                        FilledSc15: maindata.filledSc15,
                        FilledSt16: maindata.filledSt16,
                        FilledObc17: maindata.filledObc17,
                        CancelledTotal18: maindata.cancelledTotal18,
                        CancelledWomen19: maindata.cancelledWomen19,
                        CancelledSc20: maindata.cancelledSc20,
                        CancelledSt21: maindata.cancelledSt21,
                        CancelledObc22: maindata.cancelledObc22,
                        OutstandingCurrentMonthTota23: maindata.outstandingCurrentMonthTota23,
                        OutstandingCurrentMonthWomen24: maindata.outstandingCurrentMonthWomen24,
                        OutstandingCurrentMonthSc25: maindata.outstandingCurrentMonthSc25,
                        OutstandingCurrentMonthSt26: maindata.outstandingCurrentMonthSt26,
                        OutstandingCurrentMonthObc27: maindata.outstandingCurrentMonthObc27,

                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/UpdateDetailsES6', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    setFormData({

                        OutstandingPreviousMonthTotal3: maindata.outstandingPreviousMonthTotal3,
                        OutstandingPreviousMonthWomen4: maindata.outstandingPreviousMonthWomen4,
                        OutstandingPreviousMonthSc5: maindata.outstandingPreviousMonthSc5,
                        OutstandingPreviousMonthSt6: maindata.outstandingPreviousMonthSt6,
                        OutstandingPreviousMonthObc7: maindata.outstandingPreviousMonthObc7,
                        NotifiedTotal8: maindata.notifiedTotal8,
                        NotifiedWomen9: maindata.notifiedWomen9,
                        NotifiedSc10: maindata.notifiedSc10,
                        NotifieSt11: maindata.notifieSt11,
                        NotifiedObc12: maindata.notifiedObc12,
                        FilledTotal13: maindata.filledTotal13,
                        FilledWomen14: maindata.filledWomen14,
                        FilledSc15: maindata.filledSc15,
                        FilledSt16: maindata.filledSt16,
                        FilledObc17: maindata.filledObc17,
                        CancelledTotal18: maindata.cancelledTotal18,
                        CancelledWomen19: maindata.cancelledWomen19,
                        CancelledSc20: maindata.cancelledSc20,
                        CancelledSt21: maindata.cancelledSt21,
                        CancelledObc22: maindata.cancelledObc22,
                        OutstandingCurrentMonthTota23: maindata.outstandingCurrentMonthTota23,
                        OutstandingCurrentMonthWomen24: maindata.outstandingCurrentMonthWomen24,
                        OutstandingCurrentMonthSc25: maindata.outstandingCurrentMonthSc25,
                        OutstandingCurrentMonthSt26: maindata.outstandingCurrentMonthSt26,
                        OutstandingCurrentMonthObc27: maindata.outstandingCurrentMonthObc27,

                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };
    const onInputChange1 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES6total1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    if (maindata === "Error") {

                        setFormData({ ...formData, [e.target.name]: Number(formData[e.target.name]) });
                        Swal.fire({
                            title: 'Total Should be Greater from all categories',
                            text: 'Total of No of outstanding vacancies at the end of previous month',
                            icon: 'error',

                        })
                        e.target.value = formData[e.target.name]



                    } else {


                        setFormData({
                            OutstandingPreviousMonthTotal3: maindata.outstandingPreviousMonthTotal3,
                            OutstandingPreviousMonthWomen4: maindata.outstandingPreviousMonthWomen4,
                            OutstandingPreviousMonthSc5: maindata.outstandingPreviousMonthSc5,
                            OutstandingPreviousMonthSt6: maindata.outstandingPreviousMonthSt6,
                            OutstandingPreviousMonthObc7: maindata.outstandingPreviousMonthObc7,
                            NotifiedTotal8: maindata.notifiedTotal8,
                            NotifiedWomen9: maindata.notifiedWomen9,
                            NotifiedSc10: maindata.notifiedSc10,
                            NotifieSt11: maindata.notifieSt11,
                            NotifiedObc12: maindata.notifiedObc12,
                            FilledTotal13: maindata.filledTotal13,
                            FilledWomen14: maindata.filledWomen14,
                            FilledSc15: maindata.filledSc15,
                            FilledSt16: maindata.filledSt16,
                            FilledObc17: maindata.filledObc17,
                            CancelledTotal18: maindata.cancelledTotal18,
                            CancelledWomen19: maindata.cancelledWomen19,
                            CancelledSc20: maindata.cancelledSc20,
                            CancelledSt21: maindata.cancelledSt21,
                            CancelledObc22: maindata.cancelledObc22,
                            OutstandingCurrentMonthTota23: maindata.outstandingCurrentMonthTota23,
                            OutstandingCurrentMonthWomen24: maindata.outstandingCurrentMonthWomen24,
                            OutstandingCurrentMonthSc25: maindata.outstandingCurrentMonthSc25,
                            OutstandingCurrentMonthSt26: maindata.outstandingCurrentMonthSt26,
                            OutstandingCurrentMonthObc27: maindata.outstandingCurrentMonthObc27,

                            UserId: Number(localStorage.getItem("userId")),
                            ParametersId: Number(props.parametersId),
                            EmploymentId: Number(props.employmentId),

                        });
                    }
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };
    const onInputChange2 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES6total2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    if (maindata === "Error") {

                        setFormData({ ...formData, [e.target.name]: Number(formData[e.target.name]) });
                        Swal.fire({
                            title: 'Total Should be Greater from all categories',
                            text: 'Total of Notified',
                            icon: 'error',

                        })
                        e.target.value = formData[e.target.name]



                    } else {


                        setFormData({
                            OutstandingPreviousMonthTotal3: maindata.outstandingPreviousMonthTotal3,
                            OutstandingPreviousMonthWomen4: maindata.outstandingPreviousMonthWomen4,
                            OutstandingPreviousMonthSc5: maindata.outstandingPreviousMonthSc5,
                            OutstandingPreviousMonthSt6: maindata.outstandingPreviousMonthSt6,
                            OutstandingPreviousMonthObc7: maindata.outstandingPreviousMonthObc7,
                            NotifiedTotal8: maindata.notifiedTotal8,
                            NotifiedWomen9: maindata.notifiedWomen9,
                            NotifiedSc10: maindata.notifiedSc10,
                            NotifieSt11: maindata.notifieSt11,
                            NotifiedObc12: maindata.notifiedObc12,
                            FilledTotal13: maindata.filledTotal13,
                            FilledWomen14: maindata.filledWomen14,
                            FilledSc15: maindata.filledSc15,
                            FilledSt16: maindata.filledSt16,
                            FilledObc17: maindata.filledObc17,
                            CancelledTotal18: maindata.cancelledTotal18,
                            CancelledWomen19: maindata.cancelledWomen19,
                            CancelledSc20: maindata.cancelledSc20,
                            CancelledSt21: maindata.cancelledSt21,
                            CancelledObc22: maindata.cancelledObc22,
                            OutstandingCurrentMonthTota23: maindata.outstandingCurrentMonthTota23,
                            OutstandingCurrentMonthWomen24: maindata.outstandingCurrentMonthWomen24,
                            OutstandingCurrentMonthSc25: maindata.outstandingCurrentMonthSc25,
                            OutstandingCurrentMonthSt26: maindata.outstandingCurrentMonthSt26,
                            OutstandingCurrentMonthObc27: maindata.outstandingCurrentMonthObc27,

                            UserId: Number(localStorage.getItem("userId")),
                            ParametersId: Number(props.parametersId),
                            EmploymentId: Number(props.employmentId),

                        });
                    }
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };
    const onInputChange3 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES6total3', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    if (maindata === "Error") {

                        setFormData({ ...formData, [e.target.name]: Number(formData[e.target.name]) });
                        Swal.fire({
                            title: 'Total Should be Greater from all categories',
                            text: 'Total of Filled',
                            icon: 'error',

                        })
                        e.target.value = formData[e.target.name]



                    } else {


                        setFormData({
                            OutstandingPreviousMonthTotal3: maindata.outstandingPreviousMonthTotal3,
                            OutstandingPreviousMonthWomen4: maindata.outstandingPreviousMonthWomen4,
                            OutstandingPreviousMonthSc5: maindata.outstandingPreviousMonthSc5,
                            OutstandingPreviousMonthSt6: maindata.outstandingPreviousMonthSt6,
                            OutstandingPreviousMonthObc7: maindata.outstandingPreviousMonthObc7,
                            NotifiedTotal8: maindata.notifiedTotal8,
                            NotifiedWomen9: maindata.notifiedWomen9,
                            NotifiedSc10: maindata.notifiedSc10,
                            NotifieSt11: maindata.notifieSt11,
                            NotifiedObc12: maindata.notifiedObc12,
                            FilledTotal13: maindata.filledTotal13,
                            FilledWomen14: maindata.filledWomen14,
                            FilledSc15: maindata.filledSc15,
                            FilledSt16: maindata.filledSt16,
                            FilledObc17: maindata.filledObc17,
                            CancelledTotal18: maindata.cancelledTotal18,
                            CancelledWomen19: maindata.cancelledWomen19,
                            CancelledSc20: maindata.cancelledSc20,
                            CancelledSt21: maindata.cancelledSt21,
                            CancelledObc22: maindata.cancelledObc22,
                            OutstandingCurrentMonthTota23: maindata.outstandingCurrentMonthTota23,
                            OutstandingCurrentMonthWomen24: maindata.outstandingCurrentMonthWomen24,
                            OutstandingCurrentMonthSc25: maindata.outstandingCurrentMonthSc25,
                            OutstandingCurrentMonthSt26: maindata.outstandingCurrentMonthSt26,
                            OutstandingCurrentMonthObc27: maindata.outstandingCurrentMonthObc27,

                            UserId: Number(localStorage.getItem("userId")),
                            ParametersId: Number(props.parametersId),
                            EmploymentId: Number(props.employmentId),

                        });
                    }
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };
    const onInputChange4 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES6total4', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    if (maindata === "Error") {

                        setFormData({ ...formData, [e.target.name]: Number(formData[e.target.name]) });
                        Swal.fire({
                            title: 'Total Should be Greater from all categories',
                            text: 'Total of Cancelled',
                            icon: 'error',

                        })
                        e.target.value = formData[e.target.name]



                    } else {


                        setFormData({
                            OutstandingPreviousMonthTotal3: maindata.outstandingPreviousMonthTotal3,
                            OutstandingPreviousMonthWomen4: maindata.outstandingPreviousMonthWomen4,
                            OutstandingPreviousMonthSc5: maindata.outstandingPreviousMonthSc5,
                            OutstandingPreviousMonthSt6: maindata.outstandingPreviousMonthSt6,
                            OutstandingPreviousMonthObc7: maindata.outstandingPreviousMonthObc7,
                            NotifiedTotal8: maindata.notifiedTotal8,
                            NotifiedWomen9: maindata.notifiedWomen9,
                            NotifiedSc10: maindata.notifiedSc10,
                            NotifieSt11: maindata.notifieSt11,
                            NotifiedObc12: maindata.notifiedObc12,
                            FilledTotal13: maindata.filledTotal13,
                            FilledWomen14: maindata.filledWomen14,
                            FilledSc15: maindata.filledSc15,
                            FilledSt16: maindata.filledSt16,
                            FilledObc17: maindata.filledObc17,
                            CancelledTotal18: maindata.cancelledTotal18,
                            CancelledWomen19: maindata.cancelledWomen19,
                            CancelledSc20: maindata.cancelledSc20,
                            CancelledSt21: maindata.cancelledSt21,
                            CancelledObc22: maindata.cancelledObc22,
                            OutstandingCurrentMonthTota23: maindata.outstandingCurrentMonthTota23,
                            OutstandingCurrentMonthWomen24: maindata.outstandingCurrentMonthWomen24,
                            OutstandingCurrentMonthSc25: maindata.outstandingCurrentMonthSc25,
                            OutstandingCurrentMonthSt26: maindata.outstandingCurrentMonthSt26,
                            OutstandingCurrentMonthObc27: maindata.outstandingCurrentMonthObc27,

                            UserId: Number(localStorage.getItem("userId")),
                            ParametersId: Number(props.parametersId),
                            EmploymentId: Number(props.employmentId),

                        });
                    }
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };
    const onInputChange5 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Calculation/UpdateDetailsES6total5', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    if (maindata === "Error") {

                        setFormData({ ...formData, [e.target.name]: Number(formData[e.target.name]) });
                        Swal.fire({
                            title: 'Total Should be Greater from all categories',
                            text: 'Total of No of outstanding vacancies at the end of current month',
                            icon: 'error',

                        })
                        e.target.value = formData[e.target.name]



                    } else {


                        setFormData({
                            OutstandingPreviousMonthTotal3: maindata.outstandingPreviousMonthTotal3,
                            OutstandingPreviousMonthWomen4: maindata.outstandingPreviousMonthWomen4,
                            OutstandingPreviousMonthSc5: maindata.outstandingPreviousMonthSc5,
                            OutstandingPreviousMonthSt6: maindata.outstandingPreviousMonthSt6,
                            OutstandingPreviousMonthObc7: maindata.outstandingPreviousMonthObc7,
                            NotifiedTotal8: maindata.notifiedTotal8,
                            NotifiedWomen9: maindata.notifiedWomen9,
                            NotifiedSc10: maindata.notifiedSc10,
                            NotifieSt11: maindata.notifieSt11,
                            NotifiedObc12: maindata.notifiedObc12,
                            FilledTotal13: maindata.filledTotal13,
                            FilledWomen14: maindata.filledWomen14,
                            FilledSc15: maindata.filledSc15,
                            FilledSt16: maindata.filledSt16,
                            FilledObc17: maindata.filledObc17,
                            CancelledTotal18: maindata.cancelledTotal18,
                            CancelledWomen19: maindata.cancelledWomen19,
                            CancelledSc20: maindata.cancelledSc20,
                            CancelledSt21: maindata.cancelledSt21,
                            CancelledObc22: maindata.cancelledObc22,
                            OutstandingCurrentMonthTota23: maindata.outstandingCurrentMonthTota23,
                            OutstandingCurrentMonthWomen24: maindata.outstandingCurrentMonthWomen24,
                            OutstandingCurrentMonthSc25: maindata.outstandingCurrentMonthSc25,
                            OutstandingCurrentMonthSt26: maindata.outstandingCurrentMonthSt26,
                            OutstandingCurrentMonthObc27: maindata.outstandingCurrentMonthObc27,

                            UserId: Number(localStorage.getItem("userId")),
                            ParametersId: Number(props.parametersId),
                            EmploymentId: Number(props.employmentId),

                        });
                    }
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };




    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };



    useEffect(() => {
        getdata()

    }, [props.Change])




    return (
        load ? null :
            <tr scope="row"  >
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.sno}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.name}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OutstandingPreviousMonthTotal3"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="OutstandingPreviousMonthTotal3"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.OutstandingPreviousMonthTotal3}
                    /> : formData.OutstandingPreviousMonthTotal3}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OutstandingPreviousMonthWomen4"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="OutstandingPreviousMonthWomen4"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()} defaultValue={formData.OutstandingPreviousMonthWomen4}
                    /> : formData.OutstandingPreviousMonthWomen4}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OutstandingPreviousMonthSc5"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="OutstandingPreviousMonthSc5"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.OutstandingPreviousMonthSc5}
                    /> : formData.OutstandingPreviousMonthSc5}
                </td>

                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OutstandingPreviousMonthSt6"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="OutstandingPreviousMonthSt6"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.OutstandingPreviousMonthSt6}
                    /> : formData.OutstandingPreviousMonthSt6}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OutstandingPreviousMonthObc7"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="OutstandingPreviousMonthObc7"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange1(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.OutstandingPreviousMonthObc7}
                    /> : formData.OutstandingPreviousMonthObc7}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="NotifiedTotal8"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="NotifiedTotal8"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.NotifiedTotal8}
                    /> : formData.NotifiedTotal8}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="NotifiedWomen9"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="NotifiedWomen9"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.NotifiedWomen9}
                    /> : formData.NotifiedWomen9}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="NotifiedSc10"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="NotifiedSc10"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.NotifiedSc10}
                    /> : formData.NotifiedSc10}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="NotifieSt11"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="NotifieSt11"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.NotifieSt11}
                    /> : formData.NotifieSt11}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="NotifiedObc12"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="NotifiedObc12"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange2(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.NotifiedObc12}
                    /> : formData.NotifiedObc12}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="FilledTotal13"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="FilledTotal13"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.FilledTotal13}
                    /> : formData.FilledTotal13}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="FilledWomen14"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="FilledWomen14"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.FilledWomen14}
                    /> : formData.FilledWomen14}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="FilledSc15"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="FilledSc15"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.FilledSc15}
                    /> : formData.FilledSc15}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="FilledSt16"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="FilledSt16"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.FilledSt16}
                    /> : formData.FilledSt16}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="FilledObc17"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="FilledObc17"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.FilledObc17}
                    /> : formData.FilledObc17}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="CancelledTotal18"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="CancelledTotal18"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.CancelledTotal18}
                    /> : formData.CancelledTotal18}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="CancelledWomen19"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="CancelledWomen19"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.CancelledWomen19}
                    /> : formData.CancelledWomen19}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="CancelledSc20"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="CancelledSc20"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.CancelledSc20}
                    /> : formData.CancelledSc20}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="CancelledSt21"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="CancelledSt21"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.CancelledSt21}
                    /> : formData.CancelledSt21}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="CancelledObc22"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="CancelledObc22"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange4(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.CancelledObc22}
                    /> : formData.CancelledObc22}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OutstandingCurrentMonthTota23"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="OutstandingCurrentMonthTota23"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.OutstandingCurrentMonthTota23}
                    /> : formData.OutstandingCurrentMonthTota23}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OutstandingCurrentMonthWomen24"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="OutstandingCurrentMonthWomen24"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.OutstandingCurrentMonthWomen24}
                    /> : formData.OutstandingCurrentMonthWomen24}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OutstandingCurrentMonthSc25"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="OutstandingCurrentMonthSc25"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.OutstandingCurrentMonthSc25}
                    /> : formData.OutstandingCurrentMonthSc25}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OutstandingCurrentMonthSt26"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="OutstandingCurrentMonthSt26"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.OutstandingCurrentMonthSt26}
                    /> : formData.OutstandingCurrentMonthSt26}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OutstandingCurrentMonthObc27"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="OutstandingCurrentMonthObc27"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange5(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.OutstandingCurrentMonthObc27}
                    /> : formData.OutstandingCurrentMonthObc27}
                </td>
            </tr>
    );
};

export default ES6Update;
